import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import type React from 'react'
import { useSelector } from 'react-redux'

import { clsJoin } from '@/utils'
import { SectionToolbar } from '../SectionToolbar'
import { Input } from './Input'
import { IconCollapse } from './icons'
import css from './styles.module.css'
import { useSectionRow } from './useSectionRow'

type SectionRowProps = {
  id: string
  index: number
  last: boolean
}

export const SectionRow: React.FC<SectionRowProps> = ({ id, index, last }) => {
  const section = useSelector(
    migrationProjectSelector.getProjectSectionById(id)
  )

  if (!section) {
    return null
  }

  const {
    textSize,
    colorHex,
    previewColor,
    scale,
    hasNotAvailableAccess,
    disabledCss,
    collapsed,
    sectionName,
    disabledUp,
    disabledDown,
    colorId,
    isSelected,
    name,
    isEditing,
    setSectionName,
    clickOutside,
    handleMoveUpClick,
    handleMoveDownClick,
    handleDeleteClick,
    handleDuplicateClick,
    handlePasteClick,
    pasting,
    handleColorChange,
    handleTitleClick,
    handleCollapseClick,
    handleChangeTextSize,
    handleTitleUpdate,
  } = useSectionRow(section, id, index, last)

  const containerCn = clsJoin(
    css.container,
    disabledCss && css.disabled,
    collapsed && css.collapsed
  )

  const titleCn = clsJoin(
    css.title,
    collapsed && css.collapsed,
    index === 0 && css.is_first_el
  )

  const collapseBtnCn = clsJoin(css.collapse_button, collapsed && css.collapsed)

  return (
    <div
      className={containerCn}
      // @ts-expect-error
      style={{ '--section-color': previewColor || colorHex }}
    >
      <div {...clickOutside}>
        <div className={css.title_wrapper}>
          <div className={titleCn}>
            <div className={css.title_border}>
              {isEditing ? (
                <Input
                  className={clsJoin(css.input, css[textSize])}
                  value={sectionName.slice(0, 30)}
                  onUpdate={handleTitleUpdate}
                  onChange={setSectionName}
                />
              ) : (
                <>
                  <button
                    onClick={handleTitleClick}
                    className={clsJoin(css.title_button, css[textSize])}
                  >
                    <span className={css.name}>
                      {name.trim().length > 0 && name.slice(0, 30)}
                    </span>

                    <div
                      className={collapseBtnCn}
                      onClick={handleCollapseClick}
                    >
                      <IconCollapse size={13} fill={collapsed} />
                    </div>
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
        {isSelected && (
          <SectionToolbar
            colorId={colorId}
            disabledDown={disabledDown}
            disabledUp={disabledUp}
            onChangeColor={handleColorChange}
            onChangeTextSize={handleChangeTextSize}
            onDelete={handleDeleteClick}
            onDuplicate={handleDuplicateClick}
            onMoveDown={handleMoveDownClick}
            onMoveUp={handleMoveUpClick}
            onPaste={handlePasteClick}
            pasting={pasting}
            scale={scale}
            textSize={textSize}
            textSizeDisabled={hasNotAvailableAccess}
          />
        )}
      </div>
    </div>
  )
}
